import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const changeInstituteStatusApi = async(params) => {
    const response = await axios({
        url: `${config.api.base_url}institute/change-status`,
        method: "put",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default changeInstituteStatusApi